/**
 * @generated SignedSource<<db62ce85a532466a46974e3357a4b5ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavItemBadge_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useNotificationsConfig_viewer">;
  readonly " $fragmentType": "NavItemBadge_viewer";
};
export type NavItemBadge_viewer$key = {
  readonly " $data"?: NavItemBadge_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavItemBadge_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavItemBadge_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useNotificationsConfig_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "e151b0c4a674d8fd805dc0c04b010f92";

export default node;
